export default "__VITE_ASSET__CkO2j7dB__"